module.exports = __webpack_public_path__ + "img/vector-next-unactive.933ffb0f.svg";